module.exports = __webpack_public_path__ + "static/media/icomoon.9f52ad73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.svg?l3qv7r
// module id = 2685
// module chunks = 33